export default __webpack_public_path__ + "static/ron-7038aed93e59233731c2aded8a8261a3.png";